export const hasParent = (
  element: Element,
  matcher: (parent: Element) => boolean,
  searchDepth = 5
): boolean => {
  if (searchDepth === 0) {
    return false;
  }

  const parent = element.parentElement;
  if (!parent) {
    return false;
  }
  if (matcher(parent)) {
    return true;
  } else {
    return hasParent(parent, matcher, searchDepth - 1);
  }
};

export const getStyle = (element: Element, prop: string) =>
  getComputedStyle(element, null).getPropertyValue(prop);

export const getScrollParent = (element: Element): Element => {
  const regex = /(auto|scroll)/;

  const getOverflowValues = (el: Element) =>
    getStyle(el, 'overflow') + getStyle(el, 'overflow-y') + getStyle(el, 'overflow-x');

  const isScroll = (el: Element) => regex.test(getOverflowValues(el));

  const searchParents = (el: Element | null): Element => {
    if (el !== null && isScroll(el)) {
      return el;
    }
    if (el === null || el.parentElement === null) {
      return document.scrollingElement || document.documentElement;
    }
    return searchParents(el.parentElement);
  };

  return searchParents(element);
};
